import { mkConfig, generateCsv } from "export-to-csv"
var CryptoJS = require("crypto-js");

let apiUrl = process.env.VUE_APP_API_URL
let apiSpecieUrl = process.env.VUE_APP_SPECIE_API_URL
let mlUrl = process.env.VUE_APP_ML_URL
let deployment = process.env.VUE_APP_DEPLOYMENT


function ifItems(data) {
    // HACK: switches between paginated and non paginated response
    // console.log(data)
    if (data.items) {
	return data.items
    } else {
	return data
    }
}


function isDevelopDeployment(){
    return deployment === "develop"
}


function getUrl(endpoint, query=null) {
    let url_stripped = apiUrl.replace(/\/$/, '')
    // change endpoint if specie filter is passed
    if (query) {
        if (query.species_filter) {
            if (query.species_filter.length > 1) {
                url_stripped = apiSpecieUrl.replace(/\/$/, '')
            }
        }
    }
    const endpoint_stripped = endpoint.replace(/^\//, '')
    let url = new URL(`${url_stripped}/${endpoint_stripped}`)
    if (query) {
	let qs = new URLSearchParams(query)
	url.search = qs.toString()
    }
    return url.href
}

function getMlUrl(endpoint, query=null) {
    const url_stripped = mlUrl.replace(/\/$/, '')
    const endpoint_stripped = endpoint.replace(/^\//, '')
    let url = new URL(`${url_stripped}/${endpoint_stripped}`)
    if (query) {
	let qs = new URLSearchParams(query)
	url.search = qs.toString()
    }
    return url.href
}

function chunkArray(bigArray, size){
    var arrayOfArrays = [];
    for (var i=0; i < bigArray.length; i+=size) {
	arrayOfArrays.push(bigArray.slice(i, i + size));
    }
    return arrayOfArrays
}

function getMD5(binary){
    return CryptoJS.MD5(CryptoJS.enc.Latin1.parse(binary)).toString();
}


async function readBinaryFile(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onloadend = function() {
            resolve(reader.result)
        };
        reader.onerror = reject
        reader.readAsBinaryString(file);
    });
}

function deleteBeforeFinalSlash(object) {
    for (const value of Object.values(object)) {
        const string = value.Key
        const lastSlashIndex = string.lastIndexOf('/');
        if (lastSlashIndex !== -1) {
            value.filename = string.substring(lastSlashIndex + 1);
        } else {
        value.filename = value.Key
        }
    }
    console.log(object)
    return object
}

function removeFileExtension(fileName) {
    return (fileName.slice(0, fileName.lastIndexOf('.')))
}

/**
 * @param {string} content the contents of the file
 * @param {string} fileName a name for the file, with no file extension
 * @param {string} fileExtensionNoDot a file extension without a full stop
 * @param {string} mimeType the mime type for the file
 */
function saveTextFileLocally(
    content,
    fileName = 'file',
    fileExtensionNoDot,
    mimeType = 'text/plain') {
      
    if (content != null) {
        const blob = new Blob([content], { type: mimeType })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${fileName}.${fileExtensionNoDot}`
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    } else {
        console.log('please provide file content')
    }
}

function JSONtoCSV(data, headers) {
    const csvConfig = mkConfig({ 
        useKeysAsHeaders: false,
        columnHeaders: headers
    })
    return generateCsv(csvConfig)(data)
}

function JSONtoTSV(data, headers) {
    const csvConfig = mkConfig({ 
        useKeysAsHeaders: false,
        fieldSeparator: "\t",
        showColumnHeaders: false,
        columnHeaders: headers
    })
    return generateCsv(csvConfig)(data)
}

function addColumns(items, additionalColumns){
    if (additionalColumns){
        return items.map(dictionary => ({
            ...additionalColumns,
            ...dictionary
        }))
    } else {
        return items
    }
}

function popItem(itemToPop, array){
    const index = array.indexOf(itemToPop)
    if (index > -1) {
        array.splice(index, 1)
    }
    return array
}

export { 
    getMD5,
    ifItems,
    chunkArray,
    readBinaryFile,
    getUrl,
    getMlUrl,
    deleteBeforeFinalSlash,
    removeFileExtension,
    saveTextFileLocally,
    JSONtoCSV,
    JSONtoTSV,
    addColumns,
    isDevelopDeployment,
    popItem,
}

